import { create, useStore } from "zustand";
import { IDApp, TEcosystem, TTag } from "./types";

export interface IDAppsStore {
  dApps: IDApp[];
  isAddLoading: boolean;
  page: number;
  hasMore: boolean;
  dAppForEdit: IDApp | null;
  availableTags: TTag[];
  availableEcosystems: TEcosystem[];
  isCryptoProjectLoading: boolean;

  setIsCryptoProjectLoading: (isCryptoProjectLoading: boolean) => void;
  setAvailableEcocystems: (ecosystems: TEcosystem[]) => void;
  setAvailableTags: (tags: TTag[]) => void;
  setDApps: (dApps: IDApp[]) => void;
  addDApps: (dApps: IDApp[]) => void;
  setPage: (page: number) => void;
  setHasMore: (hasMore: boolean) => void;
  setDAppForEdit: (dAppForEdit: IDApp | null) => void,
}

export const dAppsStore = create<IDAppsStore>((set) => ({
  dApps: [],
  isAddLoading: false,
  page: 1,
  hasMore: true,
  dAppForEdit: null,
  availableTags: [],
  availableEcosystems: [],
  isCryptoProjectLoading: false,
  
  setIsCryptoProjectLoading: (isCryptoProjectLoading) => set({ isCryptoProjectLoading }),
  setAvailableEcocystems: (ecosystems) => set({ availableEcosystems: ecosystems }),
  setAvailableTags: (tags) => set({ availableTags: tags }),
  setDApps: (dApps) => set({ dApps }),
  addDApps: (dApps) => set((state) => ({ dApps: [...state.dApps, ...dApps] })),
  setPage: (page) => set({ page }),
  setHasMore: (hasMore) => set({ hasMore }),
  setDAppForEdit: (dAppForEdit) => set({ dAppForEdit }),
}));

export const useDAppsStore = () => useStore(dAppsStore);
